import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.conc = languageMap.concurnas = bracketIndenting()
